<template>
  <v-dialog :model-value="dialog" max-width="400" @click:outside="close" >
    <v-card>
      <v-card-title class="pt-4">Delete</v-card-title>
      <v-card-text class="pl-4 pt-0">
        Delete <strong>{{ name ? name : 'instance' }}</strong>?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            :loading="loading"
            color="red darken-1"
            text
            @click="deleteInstance(); $emit('delete', currentItem.id)"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>


export default {
  name: "DeleteDialog",
  props: {
    propertyName: {required: false},
    storeNameSpace: {required: true},
    stateKey: {required: false, default: 'currentItem'}
  },
  data: () => ({
    loading: false
  }),
  computed: {
    dialog() {
      return this.$store.state[this.storeNameSpace].deleteDialog
    },
    currentItem() {
      return this.$store.state[this.storeNameSpace][this.stateKey]
    },
    name() {
      return this.currentItem ? this.currentItem[this.propertyName] : null
    }
  },
  methods: {
    close() {
      this.$store.dispatch(`${this.storeNameSpace}` + '/toggleDeleteDialog')
    },
    async deleteInstance() {
      this.loading = true
      try {
        await this.$store.dispatch(`${this.storeNameSpace}` + '/deleteItem', this.currentItem.id)
      } catch {
        this.loading = false
      }
      this.loading = false
      this.close()
    }
  },
}
</script>

